import { useEffect, useMemo } from 'react';

import { useQltSlotAttendanceStore } from '../../stores/qlt';
import { useSubmissionStore } from './store';
import { groupTasks, rosterOf } from './submissions';

/** Starts the period's homework read; the store skips a roster it already holds. */
function useSubmissionLoad(enabled: boolean) {
  const rows = useQltSlotAttendanceStore((state) => state.rows);
  const roster = useMemo(() => rosterOf(rows), [rows]);
  const codes = useMemo(() => roster.map((student) => student.code), [roster]);
  const key = codes.join(',');
  useEffect(() => { if (enabled && codes.length > 0) void useSubmissionStore.getState().load(key, codes); }, [enabled, key]);
  return { roster, codes, key };
}

/** Warms Bài tập without subscribing to its rows. */
export function useSubmissionPrefetch(enabled: boolean) {
  useSubmissionLoad(enabled);
}

/** The period's roster and the homework it handed in. */
export function useClassSubmissions(enabled = true) {
  const { roster, codes, key } = useSubmissionLoad(enabled);
  const rosterLoading = useQltSlotAttendanceStore((state) => state.loading);
  const loading = useSubmissionStore((state) => state.loading);
  const error = useSubmissionStore((state) => state.error);
  const submissions = useSubmissionStore((state) => state.submissions);
  const courseTitles = useSubmissionStore((state) => state.courseTitles);
  const tasks = useMemo(() => groupTasks(submissions, roster), [submissions, roster]);
  return { roster, rosterLoading, loading, error, tasks, courseTitles, reload: () => void useSubmissionStore.getState().load(key, codes, true) };
}
